import { createSlice } from "@reduxjs/toolkit";
interface ActionPayload {
  renderAPIFlag: boolean;
}

const initialState: ActionPayload = {
  renderAPIFlag: false,
};

const Global = createSlice({
  name: "Global",
  initialState,
  reducers: {
    setRenderAPI: (state: any) => {
      state.renderAPIFlag = true;
    },
    clearRenderAPI: (state: any) => {
      state.renderAPIFlag = false;
    },
  },
});

export const { setRenderAPI, clearRenderAPI } = Global.actions;
export default Global;
